import type { RiskCard, RiskCardDetail, RiskMeasure } from '../model/riskSchema';

/** GET /api/risks/cards — карты рисков. Бэкенд: probability/severity 1..5; risk_score = P×S; level вычисляется. */
export const riskCards: RiskCard[] = [
  {
    id: 1,
    workplaceId: 'РМ-001',
    workplace: 'РМ-001 Сварщик',
    hazard: 'Термические ожоги',
    probability: 3,
    severity: 4,
    level: 'Высокий',
    riskScore: 12,
    status: 'ok',
    justification: 'Работа с открытым пламенем, брызги расплавленного металла',
    source: 'Акт расследования №12/2025',
    reviewDate: '01.06.2026',
  },
  {
    id: 2,
    workplaceId: 'РМ-001',
    workplace: 'РМ-001 Сварщик',
    hazard: 'Вредные аэрозоли',
    probability: 2,
    severity: 3,
    level: 'Средний',
    riskScore: 6,
    status: 'ok',
    justification: 'ПДК сварочных аэрозолей превышен в 1.5 раза',
    source: 'Протокол лаб. измерений №145',
    reviewDate: '01.06.2026',
  },
  {
    id: 3,
    workplaceId: 'РМ-012',
    workplace: 'РМ-012 Крановщик',
    hazard: 'Падение груза',
    probability: 2,
    severity: 5,
    level: 'Критический',
    riskScore: 10,
    status: 'info',
    justification: 'Зона перемещения грузов, масса до 5 т',
    source: 'ГОСТ 12.3.009-76',
    reviewDate: '15.05.2026',
  },
  {
    id: 4,
    workplaceId: 'РМ-023',
    workplace: 'РМ-023 Токарь',
    hazard: 'Порезы, захват станком',
    probability: 3,
    severity: 3,
    level: 'Средний',
    riskScore: 9,
    status: 'ok',
    justification: 'Работа с вращающимися заготовками и стружкой',
    source: 'ИОТ-007-2025',
    reviewDate: '10.09.2026',
  },
  {
    id: 5,
    workplaceId: 'РМ-047',
    workplace: 'РМ-047 Слесарь',
    hazard: 'Падение с высоты',
    probability: 2,
    severity: 4,
    level: 'Средний',
    riskScore: 8,
    status: 'info',
    justification: 'Ремонт оборудования на высоте более 1.8 м',
    source: 'ПОТ Р М-012-2000',
    reviewDate: '01.08.2026',
  },
];

const riskCardDetailExtras: Partial<Record<number, Pick<RiskCardDetail, 'residualRiskNotes' | 'timeline'>>> = {
  1: {
    residualRiskNotes: 'После установки экранов и локальной вытяжки ожидается снижение P до 2.',
    timeline: [
      { date: '01.06.2025', event: 'Идентификация опасности при пересмотре СУОТ' },
      { date: '15.01.2026', event: 'Согласование мер по снижению риска' },
    ],
  },
  3: {
    residualRiskNotes: 'Критический уровень — допуск только при исправном грузозахвате и сигнализации.',
    timeline: [{ date: '10.04.2026', event: 'Внеплановая оценка после замечания Роструда' }],
  },
};

export function buildRiskCardDetail(card: RiskCard): RiskCardDetail {
  const extra = riskCardDetailExtras[card.id];
  const timelineDefault: RiskCardDetail['timeline'] = [
    { date: card.reviewDate ?? '—', event: 'Плановый пересмотр карты риска' },
  ];
  return {
    ...card,
    residualRiskNotes:
      extra?.residualRiskNotes ?? 'Остаточный риск после мер (типовая формулировка для мока). Уточняется на комиссии.',
    timeline: extra?.timeline ?? timelineDefault,
  };
}

/** GET /api/risks/measures — мероприятия по рискам. Бэкенд: deadline ISO, status. */
export const riskMeasures: RiskMeasure[] = [
  {
    id: 1,
    title: 'Установка защитных экранов сварочного поста',
    workplaceId: 'РМ-001',
    responsible: 'Иванов А.Н.',
    deadline: '01.05.2026',
    status: 'info',
  },
  {
    id: 2,
    title: 'Замена вентиляции в зоне сварки',
    workplaceId: 'РМ-001',
    responsible: 'Сидоров П.В.',
    deadline: '15.06.2026',
    status: 'warn',
  },
  {
    id: 3,
    title: 'Техническое освидетельствование крана №3',
    workplaceId: 'РМ-012',
    responsible: 'Козлов Д.М.',
    deadline: '10.04.2026',
    status: 'ok',
  },
  {
    id: 4,
    title: 'Замена защитных ограждений станков',
    workplaceId: 'РМ-023',
    responsible: 'Миронов Е.А.',
    deadline: '30.06.2026',
    status: 'info',
  },
  {
    id: 5,
    title: 'Инструктаж по работам на высоте',
    workplaceId: 'РМ-047',
    responsible: 'Иванова П.С.',
    deadline: '05.05.2026',
    status: 'warn',
  },
];
